import React, {useCallback, useState} from 'react';
import AutoMapSettings from './AutoMapSettings.js';
import {connect} from 'react-redux';
import MacroDetails from './macros/MacrosDetails.js';
import ModRoutes from 'components/instruments/sampledInstrument/ModRoutes.js';
import MacroKnob from './macros/MacroKnob.js';
import "../../Macros.scss";

const MacrosEffectComponent = ({effect, scrollContainer, isMacroMapping}) => {
    const [showAutoMapSettings, setShowAutoMapSettings] = useState(false);

    const generate = useCallback(() => {
        effect.generateMappings();
    }, [effect]);

    if (!effect.isEnabled()) {
        return (
            <div></div>
        );
    }

    let parameters = effect.macros.map(x => x.macroParameter);
    return (
        <div className="macros-effect">
        <div className="macros-container">
          {effect.macros.map(
              macro =>
                  <MacroKnob
                    key={macro.id}
                    scrollContainer={scrollContainer}
                    macro={macro}/>
          )}
        </div>
          <ModRoutes
            effect={effect}
            width={280}
            sequencerEngine={effect.track.sequencerEngine}
            color="red"
            parameters={parameters}
          />
         {isMacroMapping ?
           <MacroDetails effect={effect}/> : ''}
        </div>
    );
};

const mapStateToProps = (state, props) => {
  return {
      isMacroMapping: state.effects.isMacroMapping
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MacrosEffectComponent);

